export default __webpack_public_path__ + "static/media/k-fashion.3d039f43.svg";